import React, { useEffect } from "react";
import { UncontrolledDropdown, Button, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useState } from "react";

const Dropdown = ({ list = [], handler = () => {}, disable = false, Key = "" }) => {
	list = _.cloneDeep(list);
	let [selectedValue, setSelectedValue] = useState("");
	useEffect(() => {
		if (list && list.length > 0) {
			setSelectedValue(() => {
				let selected = list[0].region;
				handler(selected);
				return selected;
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Key, JSON.stringify(list)]);
	return (
		<div className="p-0">
			<UncontrolledDropdown group>
				<Button color="primary">{_.startCase(selectedValue)}</Button>
				<DropdownToggle caret color="primary" />
				<DropdownMenu>
					{list.map(({ region, _id }) => {
						return (
							<DropdownItem
								onClick={() =>
									setSelectedValue(() => {
										handler(region);
										return region;
									})
								}
							>
								{_.startCase(region)}
							</DropdownItem>
						);
					})}
				</DropdownMenu>
			</UncontrolledDropdown>
		</div>
	);
};

export default Dropdown;
